import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { AssetsSectionDTO, LiabilitiesSectionDTO } from '../../../../api/useBalanceSheetQuery';
import { Chart } from './components/Chart/Chart';
import { Label } from './components/Label/Label';

interface Props {
  assets: AssetsSectionDTO;
  liabilities?: LiabilitiesSectionDTO;
  title: string;
}

export const AssetsCard = ({ assets, liabilities, title }: Props) => {
  return (
    <Card
      p="24"
      flex="1"
      css={{
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      }}
    >
      <Text variant="cardTitle" textTransform="uppercase" mb={assets.label ? '40' : '0'}>
        {title}
      </Text>

      <Box display="flex" alignItems="center" height="100%">
        <Box
          display="flex"
          flexDirection="column"
          css={({ theme }) => ({ gap: theme.space['24'] })}
          width="25%"
        >
          <Label title={assets.label} value={assets.total} />

          {liabilities && <Label title="Liabilities" value={liabilities.total} isGainLoss />}
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          css={({ theme }) => ({ gap: theme.space['24'] })}
          flex={1}
        >
          <Chart data={assets.chart} total={assets.total} />

          {liabilities && <Chart data={liabilities.chart} total={liabilities.total} />}
        </Box>
      </Box>
    </Card>
  );
};
